import gql from 'graphql-tag';

import { AlbumFolderLinkRequestDetails } from '../fragments/picture-day';

export const albumsCreate = gql`
  mutation albumsCreate($input: AlbumsCreateInput!) {
    albumsCreate(input: $input) {
      success
      picture_day_album_folder {
        id
      }
    }
  }
`;

export const albumFolderLinkCreate = gql`
  mutation albumFolderLinkCreate($input: AlbumFolderLinkCreateInput!) {
    albumFolderLinkCreate(input: $input) {
      album_folder_link {
        id
      }
    }
  }
`;

export const albumFolderLinkRequestCreate = gql`
  mutation albumFolderLinkRequestCreate(
    $input: AlbumFolderLinkRequestCreateInput!
  ) {
    albumFolderLinkRequestCreate(input: $input) {
      album_folder_link_request {
        id
      }
    }
  }
`;

export const albumFolderLinkRequestAccept = gql`
  mutation albumFolderLinkRequestAccept(
    $input: AlbumFolderLinkRequestAcceptInput!
  ) {
    albumFolderLinkRequestAccept(input: $input) {
      success
      album_folder_link_request {
        ...AlbumFolderLinkRequestDetails
      }
    }
  }
  ${AlbumFolderLinkRequestDetails}
`;

export const albumFolderLinkRequestReject = gql`
  mutation albumFolderLinkRequestReject(
    $input: AlbumFolderLinkRequestRejectInput!
  ) {
    albumFolderLinkRequestReject(input: $input) {
      success
      album_folder_link_request {
        id
        ...AlbumFolderLinkRequestDetails
      }
    }
  }
  ${AlbumFolderLinkRequestDetails}
`;

export const albumFolderLinkRequestUpdate = gql`
  mutation albumFolderLinkRequestUpdate(
    $input: AlbumFolderLinkRequestUpdateInput!
  ) {
    albumFolderLinkRequestUpdate(input: $input) {
      success
      album_folder_link_request {
        id
        ...AlbumFolderLinkRequestDetails
      }
    }
  }
  ${AlbumFolderLinkRequestDetails}
`;
